/* eslint-disable no-unused-vars */
import React, { useState, useLayoutEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import checkBrowserSupport from "../self-assesment/browserDetect";
import VoiceService from "../voice-agent/VH-Myra-FrontEnd";
import styles from "./subheader.module.css";
import { AnalyticsService } from "../self-assesment/SelfAssesment";
// ============================================================
// CONSTANTS
// ============================================================
const LOGO_URL = "https://virdiodev.s3.us-east-2.amazonaws.com/sampleVideo/LogoPNG.png";

const trackAnalytics = (newFields) => {
  if (AnalyticsService?.trackStep) {
    try {
      const existingData = JSON.parse(localStorage.getItem("assessmentData")) || {};

      const updatedData = {
        ...existingData,
        ...newFields,
        session_last_update: new Date().toISOString(),
      };

      localStorage.setItem("assessmentData", JSON.stringify(updatedData));
      AnalyticsService.trackStep(updatedData);
    } catch (err) {
      console.error("Analytics error:", err);
    }
  }
};

export const SubPageHeader = ({ activePage, isStartedLandingFlow = false, setShowMemberBlockScreen }) => {
  const history = useHistory();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const cleanUpMyra = () => {
    if (window.mayraCode) {
      window.mayraCode.setIsVisible(false);
      window.mayraCode.forceStop();
      VoiceService.destroyMyraCompletely(false);
      window.mayraCode = null;
      window.startFlow = null;
      window.currentCommandsAudio = {};
    }

    sessionStorage.removeItem("voiceService_wasListening");
    sessionStorage.removeItem("voiceService_currentFlow");
  };

  const handleButtonClick = () => {
    const check = checkBrowserSupport("member");

    if (!check.isSupported) {
      setShowMemberBlockScreen(true);
      return;
    }
    trackAnalytics({
      userMoveBetweenSubPage: true,
    });

    // 🔥 Only clean if needed
    if (isStartedLandingFlow || window.mayraCode) {
      cleanUpMyra();
    }

    if (window.preloadAllAudios) window.preloadAllAudios();
    if (window.videoUnlockPlay) window.videoUnlockPlay();

    window.isThisFromHomeScreen = false;

    setTimeout(() => {
      if (!window.isFlutterLoaded) {
        const loader = document.getElementById("flutter-loader");
        if (loader) loader.style.display = "flex";

        const loaderText = loader?.querySelector("#loader-text");
        if (loaderText) loaderText.textContent = "Loading application...";
      }

      const flutterRoot = document.getElementById("OnDemandPlayingRoot");
      if (flutterRoot) flutterRoot.style.display = "block";

      const currentAssessmentRoot = document.getElementById("assesmentDiv");
      if (currentAssessmentRoot) currentAssessmentRoot.style.display = "none";

      localStorage.removeItem("loadSelf");
      localStorage.removeItem("startedSelf");

      window.doNextLocation = history;

      document.querySelector("html").classList = [];

      setTimeout(() => {
        window.setHideElementsElm(true);
      }, 2000);
    }, 100);
  };

  return (
    <header className={styles.siteHeader}>
      <div className={styles.siteHeaderInner}>
        <button
          onClick={() => {
            trackAnalytics({
              cameToLandingPage: true,
            });
            const isV2 = localStorage.getItem("isV2") === "true";

            if (isV2) {
              history.replace("/?gsa=v2");
            } else {
              history.replace("/");
            }
          }}
          className={styles.logoLink}
        >
          <img
            className={styles.siteLogo}
            src={LOGO_URL}
            alt="Virdio Health"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "https://placehold.co/128x32/e2e8f0/475569?text=virdio+health";
            }}
          />
        </button>

        {/* ✅ NAVIGATION */}
        <nav className={`${styles.siteNav} ${isMenuOpen ? styles.open : ""}`}>
          <button
            className={`${styles.siteNavLink} ${activePage === "how-it-works" ? styles.activeLink : ""}`}
            onClick={() => {
              trackAnalytics({
                visitedHowItWorks: true,
                userMoveBetweenSubPage: true,
              });
              history.push("/how-it-works");
            }}
          >
            How It Works
          </button>

          {/* ✅ NEW ITEM */}
          <button
            className={`${styles.siteNavLink} ${activePage === "ask-myra" ? styles.activeLink : ""}`}
            onClick={() => {
              trackAnalytics({
                visitedAskMyra: true,
                userMoveBetweenSubPage: true,
              });
              history.push("/ask-myra");
            }}
          >
            Ask Myra
          </button>

          <button
            className={`${styles.siteNavLink} ${activePage === "about" ? styles.activeLink : ""}`}
            onClick={() => {
              trackAnalytics({
                visitedAbout: true,
                userMoveBetweenSubPage: true,
              });
              history.push("/about");
            }}
          >
            About Us
          </button>
        </nav>

        <button className={styles.headerCta} onClick={handleButtonClick}>
          Member Login
        </button>
        <button className={styles.menuToggle} onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? "✕" : "☰"}
        </button>
      </div>
    </header>
  );
};
